//import angular from 'angular';

angular.module('app')
        .factory('fieldSurveyFactory', [
            'amtXlatSvc', 'amtCommandQuerySvc', 'enums', 'confirmSvc', 'exportSvc', 'notifySvc',
            function (amtXlatSvc, amtCommandQuerySvc, enums, confirmSvc, exportSvc, notifySvc) {

                // static functions
                this.export = function (criteria) {
                    exportSvc.exportData('equipment/vehicle/exportFieldSurveys', criteria, amtXlatSvc.xlat('fieldSurvey.searchExportFilename'));
                };
                
                this.startOfMonth = function () {
                    var now = new Date();

                    // return the first of the current month
                    return new Date(now.getFullYear(), now.getMonth(), 1);
                };

                // static data
                var searchCriteria = {
                    filterValues: {
                        dateFrom: this.startOfMonth(),
                        dateTo: null,
                        fleetIds: [],
                        specificationIds: [],
                        serialNumber: "",
                        statusIds: []
                    },
                    forExport: false,
                    group: [],
                    page: 1,
                    pageSize: 10,
                    skip: 0,
                    take: 10
                };

                // public interface
                return {
                    export: this.export,
                    searchCriteria: searchCriteria
                };
            }
        ]
    );
